"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactStyledFlexboxgrid = require("react-styled-flexboxgrid");
var _layout = require("@berlitz/globals/lib/components/layout");
var _style = require("./style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var BlockVideo = function BlockVideo(_ref) {
  var backgroundColor = _ref.backgroundColor,
    disablePaddingBottom = _ref.disablePaddingBottom,
    disablePaddingTop = _ref.disablePaddingTop,
    youtubeVideoId = _ref.youtubeVideoId;
  return /*#__PURE__*/_react.default.createElement(_layout.Section, {
    backgroundColor: backgroundColor,
    "data-key": "max-block-video",
    disablePaddingBottom: disablePaddingBottom,
    disablePaddingTop: disablePaddingTop,
    size: "lg"
  }, /*#__PURE__*/_react.default.createElement(_layout.Grid, null, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Row, {
    center: "lg"
  }, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Col, {
    xs: 12,
    lg: 9
  }, youtubeVideoId && /*#__PURE__*/_react.default.createElement(_style.VideoWrapper, null, /*#__PURE__*/_react.default.createElement(_style.IFrame, {
    id: youtubeVideoId,
    title: "Youtube Video",
    poster: "mqdefault"
  }))))));
};
var _default = BlockVideo;
exports.default = _default;